import { RecordingActionTypes } from '../../../frontend/common/enums/recordingEnums';
import {TranscriptionEvent} from '../../../frontend/stores/utils';
import  Dispatcher  from "../../../frontend/dispatcher";
import { HostAppSettingName, HostAppSettings } from "../../office-js/HostAppSettings";

export interface IRecordingEvent {
  event: string,
  timestamp: number
}

export class RecordingEventManager {
  private static RECORDING = 'recording';
  private static PAUSED = 'paused';
  private recordingEpochTimestampList: Array<IRecordingEvent> = [];
  private isPaused: boolean = false;

  private static instance: RecordingEventManager | null = null;

  static Initialize(): void {
    if (!HostAppSettings.IsSettingTrue(HostAppSettingName.IsRecordingEventCaptureEnabled)) {
      throw new Error('Instantiation attemp without feature HostAppSettingName.IsRecordingEventCaptureEnabled');
    }
    if (this.instance != null) {
      console.warn("Instance already Exist, use existing instance via GetInstance method.");
      return;
    }
    this.instance = new RecordingEventManager();
    Dispatcher.register(this.instance.handleActions);
  }

  static GetInstance() {
    return this.instance;
  }

  static GetRecordingEventEpochTimeList(): IRecordingEvent[] {
    if (this.instance == null) {
      return [];
    }
    return this.instance.recordingEpochTimestampList;
  }

  private constructor() {}

  public handleActions = (action: Event): void => {
    switch (action.type) {
      case RecordingActionTypes.SetRecorderReadyAction:
        this.recordingEpochTimestampList = new Array<IRecordingEvent>();
        this.recordingEpochTimestampList.push({
          event: RecordingEventManager.RECORDING,
          timestamp: new Date().getTime()
        });
        this.isPaused = false;
        break;
      case RecordingActionTypes.SetRecorderIsPaused:
        this.isPaused = (<TranscriptionEvent>action).payload;
        if (this.isPaused) {
          this.recordingEpochTimestampList.push({
            event: RecordingEventManager.PAUSED,
            timestamp: new Date().getTime()
          });
        } else {
          this.recordingEpochTimestampList.push({
            event: RecordingEventManager.RECORDING,
            timestamp: new Date().getTime()
          });
        }
        break;
      case RecordingActionTypes.SetRecordingDone:
        if (!this.isPaused) {
          this.recordingEpochTimestampList.push({
            event: RecordingEventManager.PAUSED,
            timestamp: new Date().getTime()
          });
        }
        break;
    }
  };
}
